export var getCellStyle = function (column, isTableResizing) {
    var style = {};
    style.flex = "1 1 145px";
    if (column.width) {
        var width = typeof column.width === 'string' ? column.width : "".concat(column.width, "px");
        style.width = width;
        // This allows flexbox to handle the width of the column on table resize
        if (isTableResizing && column.canResize) {
            style.flex = "".concat(Number(column.width), " ").concat(Number(column.width), " ").concat(width);
        }
        else {
            style.flex = "0 0 ".concat(width);
        }
    }
    if (column.maxWidth) {
        style.maxWidth = "".concat(column.maxWidth, "px");
    }
    if (column.minWidth) {
        style.minWidth = "".concat(column.minWidth, "px");
    }
    return style;
};
